// Supabase Storage object keys only accept a narrow ASCII set; a Chinese or
// symbol-laden filename used to make the upload fail with "Invalid key". Every
// path segment that comes from user input (file names, category titles) goes
// through here. The original name still lives in the DB (file_metadata.file_name,
// knowledgebase.documents) for display and download naming.
//
// Deterministic and identity for names that were already safe, so keys built
// for existing objects do not change.

const SAFE_SEGMENT = /^[A-Za-z0-9._-]+$/;

// FNV-1a: cheap, sync and stable across browsers; only used to keep two
// different unsafe names from sharing one key after their letters are dropped.
const shortHash = (str) => {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
};

const splitExtension = (name) => {
  const dot = name.lastIndexOf('.');
  if (dot <= 0 || dot === name.length - 1) return [name, ''];
  const ext = name.slice(dot + 1);
  return SAFE_SEGMENT.test(ext) && ext.length <= 16 ? [name.slice(0, dot), `.${ext}`] : [name, ''];
};

export const isStorageSafeSegment = (segment) => SAFE_SEGMENT.test(segment);

export const toStorageKeySegment = (name) => {
  const original = String(name ?? '').normalize('NFC').trim();
  if (!original) return `file-${shortHash(original)}`;
  if (isStorageSafeSegment(original) && original !== '.' && original !== '..') return original;
  const [base, ext] = splitExtension(original);
  const ascii = base.replace(/[^A-Za-z0-9._-]+/g, '-').replace(/^[-.]+|[-.]+$/g, '').replace(/-{2,}/g, '-').slice(0, 80);
  return `${ascii || 'file'}-${shortHash(original)}${ext}`;
};
